import { createSlice } from '@reduxjs/toolkit'
import { PAGINATION_TYPES } from '../../../utility/Constants'

export const paginateObj = {
  count: 0,
  total: 0,
  items: [],
  pagination: {
    self: 0,
    first: 0,
    last: 1,
  },
}

const initialState = {}

Object.keys(PAGINATION_TYPES).map(
  // eslint-disable-next-line no-return-assign
  (key) => (initialState[PAGINATION_TYPES[key]] = { ...paginateObj }),
)

export const PaginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    addPaginationItem: (state, { payload }) => ({
      ...state,
      [payload.key]: {
        ...state[payload.key],
        items: [payload.value, ...state[payload.key].items],
        total: state[payload.key].total + 1,
      },
    }),
    updatePaginationItem: (state, { payload }) => {
      const items = [...state[payload.key].items]
      const currentIndex = items.findIndex((item) => item.id === parseInt(payload.id, 10))
      if (currentIndex === -1) return state
      items[currentIndex] = {
        ...items[currentIndex],
        ...payload.value,
      }
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          items,
        },
      }
    },

    updateProductInOrder: (state, action) => {
      const { orderId, productId, newQuantity, rate } = action.payload;
      const orderStateKey = PAGINATION_TYPES.order;

      const orderToUpdate = state[orderStateKey].items.find(order => order.id === orderId);

      if (orderToUpdate) {
        const productToUpdate = orderToUpdate.products.find(product => product.id === productId);

        if (productToUpdate) {
          productToUpdate.quantity = newQuantity;
          productToUpdate.gross = rate * newQuantity;
        }

        orderToUpdate.gross = orderToUpdate.products.reduce(
          (total, product) => total + (product.gross || 0), 0
        );
      }
    },

    deleteProductFromOrder: (state, action) => {
      const { orderId, product_id, key } = action.payload;
      const orderStateKey = PAGINATION_TYPES.order;

      const orderToUpdate = state[orderStateKey].items.find(order => order.id === orderId);

      if (orderToUpdate) {
        const initialProductCount = orderToUpdate.products.length;
        orderToUpdate.products = orderToUpdate.products.filter(
          product => product.id !== product_id
        );

        if (orderToUpdate.products.length < initialProductCount) {
          state[orderStateKey].total -= 1;
        }

        orderToUpdate.gross = orderToUpdate.products.reduce(
          (total, product) => total + (product.gross || 0), 0
        );
      }
    },

    deletePaginationItem: (state, { payload }) => ({
      ...state,
      [payload.key]: {
        ...state[payload.key],
        items: state[payload.key].items.filter((item) => item.id !== parseInt(payload.value, 10)),
        total: state[payload.key].total - 1,
      },
    }),
    pagePaginationSuccess: (state, { payload }) => ({
      ...state,
      [payload.key]: payload.data,
    }),
  },
})

export const selectPaginationItem = (payload) => ({ pagination }) => {
  const items = [...pagination[payload.key].items]
  const currentIndex = items.findIndex((item) => item.id === parseInt(payload.id, 10))
  if (currentIndex === -1) return null
  return items[currentIndex]
}

export const {
  pagePaginationSuccess,
  addPaginationItem,
  updatePaginationItem,
  deletePaginationItem,
  updateProductInOrder,
  deleteProductFromOrder,
} = PaginationSlice.actions
export default PaginationSlice.reducer
